import(/* webpackMode: "eager" */ "/app/apps/web/app/global-error.tsx");
